var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgParentInfoIcon = function SvgParentInfoIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91434 8.76934H2.91119C1.30594 8.76934 0 10.0753 0 11.6805V16.0335H7.96822V12.1802C7.96822 11.2457 8.55119 10.4454 9.37228 10.1222C8.85528 9.30962 7.94678 8.76934 6.91434 8.76934Z",
    fill: "#36B3A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91275 3C3.56103 3 2.46131 4.09972 2.46131 5.45144C2.46131 6.80316 3.56103 7.90287 4.91275 7.90287C6.2645 7.90287 7.36419 6.80316 7.36419 5.45144C7.36419 4.09972 6.26447 3 4.91275 3Z",
    fill: "#36B3A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4206 10.6007H10.1794C9.30853 10.6007 8.6 11.3093 8.6 12.1802V16.0335H16V12.1802C16 11.3093 15.2915 10.6007 14.4206 10.6007Z",
    fill: "#36B3A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 5.98941C11.3022 5.98941 10.4904 6.80122 10.4904 7.799C10.4904 8.79681 11.3022 9.60859 12.3 9.60859C13.2978 9.60859 14.1096 8.79681 14.1096 7.799C14.1096 6.80119 13.2978 5.98941 12.3 5.98941Z",
    fill: "#36B3A8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgParentInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "parent-info-icon.47ce70ee7bee3879fa9f51293855d1b7.svg";